import { __read } from "tslib";
import { useNovaEventing } from '@nova/react';
import { AppBarEvents, } from '@office-start/appbar-events';
import React from 'react';
import useAppBarContext from './hooks/useAppBarContext';
export var AppBarImpression = function (_a) {
    var _b;
    var _c = _a.impressionStabilizeTimeout, impressionStabilizeTimeout = _c === void 0 ? 5000 : _c;
    var _d = __read(React.useState(false), 2), impressionTriggered = _d[0], setImpressionTriggered = _d[1];
    var _e = __read(React.useState(false), 2), impressionReady = _e[0], setImpressionReady = _e[1];
    var _f = __read(React.useState(false), 2), impressionRecorded = _f[0], setImpressionRecorded = _f[1];
    var novaEventing = useNovaEventing();
    var appBarContext = useAppBarContext();
    React.useEffect(function () {
        var _a;
        if (!impressionTriggered && ((_a = appBarContext.appBarData) === null || _a === void 0 ? void 0 : _a.m365Apps)) {
            setImpressionTriggered(true);
            // Give it some time to stabilize, then fire the impression event
            setTimeout(function () {
                setImpressionReady(true);
            }, impressionStabilizeTimeout);
        }
    }, [
        impressionTriggered,
        (_b = appBarContext.appBarData) === null || _b === void 0 ? void 0 : _b.m365Apps,
        impressionStabilizeTimeout,
    ]);
    React.useEffect(function () {
        if (impressionReady && !impressionRecorded) {
            setImpressionRecorded(true);
            // Fire a Nova event
            var convertItem_1 = function (item) {
                return (item &&
                    {
                        id: item.data.node.id,
                        platformType: item.data.node.platformType,
                    });
            };
            var convertItems_1 = function (items) {
                return items ? items.map(convertItem_1) : [];
            };
            var appBarImpressionEvent = AppBarEvents.appBarImpression(function () {
                return {
                    lockedTiles: convertItems_1(appBarContext.lockedItems),
                    pinnedTiles: convertItems_1(appBarContext.pinnedItems),
                    hoistedTile: appBarContext.hoistedItem
                        ? convertItem_1(appBarContext.hoistedItem)
                        : undefined,
                    overflowTiles: convertItems_1(appBarContext.overflowItems),
                };
            });
            novaEventing.generateEvent({
                event: appBarImpressionEvent,
            });
        }
    }, [novaEventing, impressionReady, impressionRecorded, appBarContext]);
    return null;
};
//# sourceMappingURL=AppBarImpression.js.map